export const pageData = [
  {
    id: 1,
    intro:
      "If you're carrying debt on a credit card or a personal loan with high interest rates, you're likely paying a significant amount in interest each year. By transferring this debt to a balance transfer option with a lower rate, you can save on interest and pay off your debt faster. Use Minemi's balance transfer calculator to see how much you could save by transferring your debt.",
    subpara:
      "Our balance transfer calculator provides an estimate of your potential savings. Input details like your current debt amount, interest rate, and transfer details to gain insights into possible savings.",
  },
];

export const savingCalculator = [
  {
    id: 1,
    title: "Balance Transfer Calculator",
    description:
      "Transferring debt to a credit card or loan with a lower interest rate can save you money on interest while you pay off your debt.",
  },
  {
    id: 2,
    inputsHeadingOne: "Your Existing Debt",
    inputsHeadingTwo: "Details of New Loan",
  },
];

export const monthlyPayment = [
  {
    id: 1,
    title: "Monthly payment calculator",
    description:
      "This calculator shows you exactly how much you would have to pay each month to eliminate credit card debt within a specific time frame.",
  },
];

export const getLoanData = [
  {
    id: 1,
    heading: "Minemi Credit Card Balance Transfer Calculator",
    subHeading:
      "See how much you could save by transferring debt from a high-interest loan or credit card to a more favorable loan.",
    notice:
      "Some of the loan products and financial services featured on this website are provided by our advertising partners. MinEMI may receive compensation when you take certain actions, such as applying for a loan, clicking on a link, or engaging with the offers listed on our site. However, this compensation does not influence our evaluations, recommendations, or the content we provide. Our goal is to help you find the best loan solutions to minimize your EMIs, and our opinions remain unbiased. We are committed to transparency, and below you will find a list of our partners, along with an explanation of how we earn revenue.",
    updationText: "Last Updated: Oct 14, 2024 ·  ",
    updateTime: "3 min read",
  },
];
